import { FormContainerStrings } from '@argenta/react-ui';
import { t } from '@lingui/macro';

export const getFormContainerI18nStrings = (): FormContainerStrings => ({
  submitButton: {
    submit: t({ id: 'vacancies.application.form.submitButton' }),
  },
});
